import palette from './palette';

/**
 * L'échelle typographique de l'application.
 *
 * 🔴 PLANCHER À 16 px. Aucune taille de ce fichier ne descend en dessous, et
 * ça ne se négocie pas au cas par cas : c'est la taille par défaut de tous les
 * navigateurs, donc celle que la personne a choisie si elle a choisi quelque
 * chose. Descendre en dessous, c'est décider à sa place que son réglage était
 * trop gros.
 *
 * ⚠️ Ce n'est pas WCAG qui l'exige — la norme demande que le texte reste
 * lisible à 200 % de zoom, sans imposer de valeur. C'est une règle de ce
 * produit, et elle est plus stricte que la norme à dessein : nos utilisatrices
 * sont des bibliothécaires bénévoles, souvent d'un certain âge, qui lisent un
 * écran de gestion à bout de bras.
 *
 * 🔑 La hiérarchie ne se fait donc PAS par la taille en bas de l'échelle, mais
 * par la COULEUR et la GRAISSE. `body2`, `caption` et `overline` valent la même
 * taille que `body1` et s'en distinguent autrement. C'est ce qui manquait : le
 * texte d'aide sous chaque commutateur du compte était en 12 px, et celui du
 * champ de délai en 11 px — précisément les textes qui expliquent à quoi on
 * s'engage en cochant.
 *
 * ⚠️ Et une raison mécanique, en plus de la lisibilité : Safari sur iOS ZOOME
 * automatiquement quand on touche un champ dont le texte fait moins de 16 px.
 * La page saute, la mise en page se décale, et il faut dézoomer à la main.
 *
 * Les interlignes suivent : 1,5 fois la taille pour le texte courant, comme le
 * demande le critère WCAG 1.4.12. Les titres restent plus serrés, un titre
 * n'étant pas fait pour être lu sur plusieurs lignes.
 */

export default {
  h1: {
    color: palette.text && palette.text.primary,
    fontWeight: 500,
    fontSize: '35px',
    letterSpacing: '-0.24px',
    lineHeight: '40px',
  },
  h2: {
    color: palette.text && palette.text.primary,
    fontWeight: 500,
    fontSize: '29px',
    letterSpacing: '-0.24px',
    lineHeight: '32px',
  },
  h3: {
    color: palette.text && palette.text.primary,
    fontWeight: 500,
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '28px',
  },
  h4: {
    color: palette.text && palette.text.primary,
    fontWeight: 500,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '24px',
  },
  h5: {
    color: palette.text && palette.text.primary,
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  h6: {
    color: palette.text && palette.text.primary,
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '24px',
  },
  subtitle1: {
    color: palette.text && palette.text.primary,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '25px',
  },
  subtitle2: {
    color: palette.text && palette.text.secondary,
    fontWeight: 400,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '24px',
  },
  body1: {
    color: palette.text && palette.text.primary,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '24px',
  },
  body2: {
    color: palette.text && palette.text.secondary,
    fontSize: '16px',
    letterSpacing: '-0.04px',
    lineHeight: '24px',
  },
  button: {
    color: palette.text && palette.text.primary,
    fontSize: '16px',
  },
  caption: {
    color: palette.text && palette.text.secondary,
    fontSize: '16px',
    letterSpacing: '0.33px',
    lineHeight: '24px',
  },
  overline: {
    color: palette.text && palette.text.secondary,
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '24px',
    textTransform: 'uppercase',
  },
};
